import { css } from '@emotion/react';

const span12of12 = css`
  flex-basis: 100%;
  max-width: 100%;
`;

const span11of12 = css`
  flex-basis: 91.66666667%;
  max-width: 91.66666667%;
`;

const span10of12 = css`
  flex-basis: 83.33333333%;
  max-width: 83.33333333%;
`;

const span9of12 = css`
  flex-basis: 75%;
  max-width: 75%;
`;

const span8of12 = css`
  flex-basis: 66.66666667%;
  max-width: 66.66666667%;
`;

const span7of12 = css`
  flex-basis: 58.33333333%;
  max-width: 58.33333333%;
`;

const span6of12 = css`
  flex-basis: 50%;
  max-width: 50%;
`;

const span5of12 = css`
  flex-basis: 41.66666667%;
  max-width: 41.66666667%;
`;

const span4of12 = css`
  flex-basis: 33.33333333%;
  max-width: 33.33333333%;
`;

const span3of12 = css`
  flex-basis: 25%;
  max-width: 25%;
`;

const span2of12 = css`
  flex-basis: 16.66666667%;
  max-width: 16.66666667%;
`;

const span1of12 = css`
  flex-basis: 8.33333333%;
  max-width: 8.33333333%;
`;

const offset1 = css`
  margin-left: 8.33333333%;
`;

const offset2 = css`
  margin-left: 16.66666667%;
`;

const offset3 = css`
  margin-left: 25%;
`;

const offset4 = css`
  margin-left: 33.33333333%;
`;

const offset5 = css`
  margin-left: 41.66666667%;
`;

const offset6 = css`
  margin-left: 50%;
`;

const offset7 = css`
  margin-left: 58.33333333%;
`;

const offset8 = css`
  margin-left: 66.66666667%;
`;

const offset9 = css`
  margin-left: 75%;
`;

const offset10 = css`{
  margin-left: 83.33333333%;
`;

const offset11 = css`{
  margin-left: 91.66666667%;
`;

const centerAlign = css`
  justify-content: center;
`;

const leftAlign = css`
  justify-content: flex-start;
`;

const rightAlign = css`
  justify-content: flex-end;
`;

export const colSet = {
  1: span1of12,
  2: span2of12,
  3: span3of12,
  4: span4of12,
  5: span5of12,
  6: span6of12,
  7: span7of12,
  8: span8of12,
  9: span9of12,
  10: span10of12,
  11: span11of12,
  12: span12of12,
};

export const offsetValues = {
  1: offset1,
  2: offset2,
  3: offset3,
  4: offset4,
  5: offset5,
  6: offset6,
  7: offset7,
  8: offset8,
  9: offset9,
  10: offset10,
  11: offset11,
};

export const alignmentValues = {
  center: centerAlign,
  left: leftAlign,
  right: rightAlign,
};
